export const FormHelper = (() => {
  const handleChange = (event, stateSetter) => {
    const { name, value } = event.target;
    stateSetter((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleChangeNoEspace = (event, stateSetter) => {
    const { name, value } = event.target;
    stateSetter((prevState) => {
      return {
        ...prevState,
        [name]: value.replace(/\s/g, ""),
      };
    });
  };

  const handleChangeSoloNumero = (event, stateSetter) => {
    const { name, value } = event.target;
    stateSetter((prevState) => {
      return {
        ...prevState,
        [name]: value.replace(/\D/g, ""),
      };
    });
  };

  // Para inputs numéricos: convierte vacío/null a 0 (evita enviar "" o null a
  // propiedades int del backend, que fallan al deserializar el JSON).
  const handleChangeNumero = (event, stateSetter) => {
    const { name, value } = event.target;
    const numero = value === "" || value === null || isNaN(Number(value)) ? 0 : Number(value);
    stateSetter((prevState) => {
      return {
        ...prevState,
        [name]: numero,
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return {
    handleChange,
    handleSubmit,
    handleChangeNoEspace,
    handleChangeSoloNumero,
    handleChangeNumero,
  };
})();
